import Vue from "vue";

// Stanje menija po korisniku: sužen meni, sažete grupe, prikačeno, nedavne stranice i restorani.
// Čuva se u localStorage (u try/catch); bez njega meni radi, samo ne pamti izbor.
const PREFIX = "restorani-nav-";
const MAX_RECENT = 6;

export const navState = Vue.observable({
  userId: null,
  rail: null, // null = po širini ekrana
  collapsed: {}, // { [groupId]: true|false }
  pins: [],
  recent: [],
  recentSites: [],
});

function persist() {
  if (!navState.userId) return;
  try {
    localStorage.setItem(
      PREFIX + navState.userId,
      JSON.stringify({
        rail: navState.rail,
        collapsed: navState.collapsed,
        pins: navState.pins,
        recent: navState.recent,
        recentSites: navState.recentSites,
      })
    );
  } catch (e) {
    /* privatni prozor ili blokiran prostor: nastavlja se bez pamćenja */
  }
}

export function loadNavPrefs(userId) {
  navState.userId = userId || null;
  let saved = {};
  try {
    saved = JSON.parse(localStorage.getItem(PREFIX + userId) || "{}") || {};
  } catch (e) {
    saved = {};
  }
  navState.rail = typeof saved.rail === "boolean" ? saved.rail : null;
  navState.collapsed = saved.collapsed && typeof saved.collapsed === "object" ? saved.collapsed : {};
  navState.pins = Array.isArray(saved.pins) ? saved.pins : [];
  navState.recent = Array.isArray(saved.recent) ? saved.recent : [];
  navState.recentSites = Array.isArray(saved.recentSites) ? saved.recentSites : [];
}

export function setRail(value) {
  navState.rail = !!value;
  persist();
}

export function setGroupOpen(groupId, open) {
  navState.collapsed = { ...navState.collapsed, [groupId]: !open };
  persist();
}

export function togglePin(key) {
  navState.pins = navState.pins.includes(key)
    ? navState.pins.filter((k) => k !== key)
    : [...navState.pins, key];
  persist();
}

export function pushRecent(key) {
  if (!key) return;
  navState.recent = [key, ...navState.recent.filter((k) => k !== key)].slice(0, MAX_RECENT);
  persist();
}

export function pushRecentSite(id) {
  navState.recentSites = [id, ...navState.recentSites.filter((k) => k !== id)].slice(0, 3);
  persist();
}
